<template>
 <div class="modal-overlay">
  <div class="forgot-password-modal">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2>Glömt lösenord</h2>
      <button class="close-btn" @click="closeModal">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <label for="email">E-post</label>
      <input type="email" id="email" v-model="email" placeholder="Ange din e-postadress" class="input-field" />
      <button :disabled="!email" class="submit-btn" @click="resetPassword">
        Återställ mitt lösenord
      </button>
      <p class="info-text">
        Skriv in din e-postadress ovan, så skickar vi en länk för att återställa ditt lösenord.
      </p>
    </div>
  </div>
 </div>
</template>
<script>
export default {
  data() {
    return {
      email: "", // Email input binding
    };
  },
  methods: {
    resetPassword() {
      if (this.email) {
        alert(`En återställningslänk har skickats till ${this.email}`);
        this.email = ""; // Clear the input field after submission
      }
    },
    closeModal() {
      // Logic to close the modal
      this.$emit("close"); // Emits an event to the parent to close the modal
    },
  },
};
</script>
<style scoped>
.forgot-password-modal {
  background-color: #1b1d2a;
  color: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 300px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  font-size: 18px;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.modal-body {
  margin-top: 20px;
}

label {
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
}

.input-field {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #4c526c;
  border-radius: 5px;
  background-color: #2a2e43;
  color: #fff;
  outline: none;
}

.input-field:focus {
  border-color: #6a77b4;
}

.submit-btn {
  margin-top: 15px;
  width: 100%;
  padding: 10px;
  background-color: #3a3e5b;
  color: #fff;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-btn:disabled {
  background-color: #2a2e43;
  cursor: not-allowed;
}

.submit-btn:hover:enabled {
  background-color: #4c526c;
}

.info-text {
  margin-top: 10px;
  font-size: 12px;
  color: #b0b4c2;
}
</style>